import Axios from "axios";

const remoteResource = 'frontend/api/v1/personalization';

let factory = function () {
    const personalizationObjects = Object.freeze(['lists'])

    const state = {
        personalization: {
            lists: []
        }
    };
    const actions = {};
    const mutations = {};
    const getters = {};

    actions.FETCH_ALL = ({commit}) => {
        personalizationObjects.map(obj => {
            return Axios.get(`${remoteResource}/${obj}?owner=6262ba81eebda54956c04c4c`)
                .then((res) => {
                    commit('SET_PERSONALIZATION', {personalizationKind: obj, data: res.data})
                })
        })
    }

    actions.FETCH_BY_USER = async ({commit}, {userId}) => {
        const response = await Axios.get(`${remoteResource}/lists?owner=${userId}`);
        commit('SET_PERSONALIZATION', {personalizationKind: 'lists', data: response.data})
    }

    actions.SAVE_PERSONALIZATION_LIST = async ({commit}, {id, listId, name, columns, conditionals, owner}) => {
        let personalizationList = {id, listId, name, columns, conditionals, owner}
        let location = (await Axios.post(`${remoteResource}/lists`, personalizationList)).headers["location"]
        let savedPersonalization = (await Axios.get(location)).data;
        commit("ADD_PERSONALIZATION", {personalizationKind: 'lists', data: savedPersonalization});
    }

    mutations.ADD_PERSONALIZATION = (state, {personalizationKind, data}) => {
        const idx = state.personalization[personalizationKind].findIndex(personalization => personalization.id == data.id);
        if (idx > -1)
            state.personalization[personalizationKind][idx] = data
        else
            state.personalization[personalizationKind].push(data);
    }

    mutations.SET_PERSONALIZATION = (state, {personalizationKind, data}) => {
        state.personalization[personalizationKind] = data;
    }

    getters.GET_PERSONALIZATION_LIST = (state) => (listId) => {

        return state.personalization.lists.find(list => list.listId == listId);
    }

    return {
        namespaced: true, getters, state, mutations, actions
    }
}

export default factory;